<ng-container *ngIf="!isGraphOnly">
  <div fxLayout="column" fxFlex="100%" fxLayoutGap="10px">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="100%" fxLayoutGap="10px" *ngIf="key == 'pSetAnalytics'">
      <mat-card fxLayout="row" fxLayout.lt-md="row wrap" fxLayoutAlign="start center" fxFlex="80%" fxFlex.lt-md="100%">
        <span pointer (click)="exit.emit({ exit: true })"><em class="fa fa-sticky-note route-icon"></em>{{ psParams.previousPsetName ? psParams.previousPsetName : "Practice Set Analytics" }}</span>
        <mat-icon>keyboard_arrow_right</mat-icon>
        <span pointer (click)="exit.emit({ key: 'user' })"><em class="fa fa-user route-icon"></em>{{ psParams.userName ? psParams.userName : "User Details" }}</span>
        <mat-icon>keyboard_arrow_right</mat-icon>
        <span><em class="fa fa-sticky-note route-icon"></em>{{ psParams.name ? psParams.name : "Practice Set Analytics" }}</span>
      </mat-card>
      <mat-card fxLayout="row" fxLayoutAlign="center center" fxFlex="20%" fxFlex.lt-md="100%">
        <app-date-selector [selectedDateRange]="dateRangeType" (changeDate)="getDate($event)"></app-date-selector>
      </mat-card>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
      <mat-card fxLayout="column" fxFlex="calc(30% - 5px)" fxFlex.lt-md="100%">
        <div fxLayoutAlign="space-between" fxLayout="row">
          <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center"> Lesson Records </mat-card-subtitle>
        </div>
        <!-- <ng-container *ngIf="!isEmptyData" class="ele-place" fxLayout="column" fxFlex="26%" fxLayoutAlign="center center"> -->
        <div *ngIf="!isEmptyData" class="ele-place" fxLayout="column" fxFlex="100%" fxLayoutAlign="center center">
          <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="padding-bottom: 25px">
            <div class="img-circle" id="parentElement" fxLayoutAlign="center center" fxLayout="column" style="text-align: center" [style.height.px]="getDynamicHeight()">
              {{ leastDifficultPSetsList.sessionsPlayed }}
              <!-- 333333333 -->
            </div>
            <span style="text-align: center">Session Played</span>
          </div>

          <div fxLayout="column" fxFlex="100%">
            <div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between baseline">
              <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="color: #c73535 !important">
                <div class="Rejected-img-circle" id="parentElement1" fxLayoutAlign="center center" fxLayout="column" style="text-align: center" [style.height.px]="getDynamicHeight1()">
                  {{ leastDifficultPSetsList.rejectedCount }}
                </div>
                <span style="text-align: center; color: #be1515">Rejected Count</span>
              </div>
              <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center">
                <div class="img-circle" id="parentElement2" fxLayoutAlign="center center" fxLayout="column" style="text-align: center" [style.height.px]="getDynamicHeight2()">
                  {{ leastDifficultPSetsList.completedSessionCount }}
                </div>
                <span style="text-align: center">Completed Session Count</span>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
      <mat-card fxLayout="column" fxFlex="calc(70% - 5px)" fxFlex.lt-md="100%" *ngIf="!breadCrumbUser">
        <div fxLayoutAlign="space-between" fxLayout="row">
          <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
            <!-- Users/Nickname -->
            Session Data
          </mat-card-subtitle>
          <app-data-export (exportData)="getCsvDataEram('userEramLessonSession')" pointer></app-data-export>
        </div>
        <app-table fxLayout="row" fxFlex [data]="data.users" pointer *ngIf="data.users" [fix]="5" (rowClicked)="openUserDialog()" [iscenterFlag]="true"></app-table>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!data.users">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-card>
      <mat-card fxLayout="column" fxFlex="calc(70% - 5px)" fxFlex.lt-md="100%" *ngIf="breadCrumbUser">
        <div fxLayoutAlign="space-between" fxLayout="row">
          <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center"> Users </mat-card-subtitle>
          <app-data-export (exportData)="getCsvDataEram('userEramLessonSession')" pointer></app-data-export>
        </div>
        <app-table fxLayout="row" fxFlex [data]="data.users" pointer *ngIf="data.users" [fix]="6"></app-table>
        <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!data.users">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-card>
    </div>
    <div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
      <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
        <mat-card-header class="grp_hdr">
          <article [ngClass]="['header-padding']">
            <div fxLayout="column" fxLayoutAlign="start center">
              <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Month'">Last 24 Month's Data</h4>
              <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Day'">Last 1 Month's Data</h4>
              <h4 ngClass="selectlist-label" *ngIf="dateType.type === 'Year'">Last 5 Year's Data</h4>
            </div>
            <nav class="nv_rt rpd">
              <div fxLayout="row" fxLayoutGap="10px">
                <div fxLayout="column" fxLayoutAlign="end center">
                  <div fxLayout="row">
                    <h4
                      ngClass="selectlist-label"
                      *ngIf="
                        usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                        usageAnalyticsSelectedValue !== 'averageDuration' &&
                        usageAnalyticsSelectedValue !== 'masteredPracticeSets' &&
                        usageAnalyticsSelectedValue === 'all'
                      "
                    >
                      Usage :
                    </h4>
                    <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'totalPlayedSession'">Total Lessons Sessions :</h4>
                    <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'averageDuration'">Average Session Duration :</h4>
                    <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'masteredPracticeSets'">Total Mastered Lessons Sets :</h4>
                    <mat-form-field class="mrgn drpdown-chart-options duration-dropdown" appearance="outline">
                      <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics" (selectionChange)="changeAnalytics($event.value)">
                        <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics" [value]="ua.value">
                          {{ ua.viewValue }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="column">
                  <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 24px; margin-top: 10px; color: #707070; cursor: pointer" (click)="exportCsvData('usage')"></i>
                </div>
              </div>
            </nav>
          </article>
        </mat-card-header>
        <mat-card-content class="flx_tm">
          <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner>
          <app-highcharts #highchartsComponent [height]="'280px'" [marginTop]="'10px'" [sereiesType]="'column'" [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
          </app-highcharts>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isGraphOnly">
  <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
    <mat-card-header class="grp_hdr">
      <article [ngClass]="['header-padding']">
        <div fxLayout="column" fxLayoutAlign="start center">
          <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Month'">Last 24 Month's Data</h4>
          <h4 ngClass="selectlist-label" *ngIf="dateType.type == 'Day'">Last 1 Month's Data</h4>
          <h4 ngClass="selectlist-label" *ngIf="dateType.type === 'Year'">Last 5 Year's Data</h4>
        </div>
        <nav class="nv_rt rpd">
          <div fxLayout="row" fxLayoutGap="10px">
            <div fxLayout="column" fxLayoutAlign="end center">
              <div fxLayout="row">
                <ng-container *ngIf="!selectedApp || selectedApp.title != 'ERAM Keyboard'; else eramApp">
                  <h4
                    ngClass="selectlist-label"
                    *ngIf="
                      usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                      usageAnalyticsSelectedValue !== 'averageDuration' &&
                      usageAnalyticsSelectedValue !== 'masteredPracticeSets' &&
                      usageAnalyticsSelectedValue === 'all'
                    "
                  >
                    Usage :
                  </h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'totalPlayedSession'">Total Practice Set Sessions :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'averageDuration'">Average Session Duration :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'masteredPracticeSets'">Mastered Practice Sets :</h4>
                </ng-container>
                <ng-template #eramApp>
                  <h4
                    ngClass="selectlist-label"
                    *ngIf="
                      usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                      usageAnalyticsSelectedValue !== 'averageDuration' &&
                      usageAnalyticsSelectedValue !== 'masteredPracticeSets' &&
                      usageAnalyticsSelectedValue === 'all'
                    "
                  >
                    Usage :
                  </h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'totalPlayedSession'">Total Lessons Sessions :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'averageDuration'">Average Session Duration :</h4>
                  <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'masteredPracticeSets'">Total Mastered Lessons Sets :</h4>
                </ng-template>

                <ng-container *ngIf="!selectedApp || selectedApp.title != 'ERAM Keyboard'; else eramAppDrop">
                  <mat-form-field class="mrgn drpdown-chart-options" appearance="outline">
                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageAnalytics" (selectionChange)="changeAnalytics($event.value)">
                      <mat-option class="drp-options" *ngFor="let ua of usageAnalytics" [value]="ua.value">
                        {{ ua.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-template #eramAppDrop>
                  <mat-form-field class="mrgn drpdown-chart-options" appearance="outline">
                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics" (selectionChange)="changeAnalytics($event.value)">
                      <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics" [value]="ua.value">
                        {{ ua.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </div>
            </div>
            <div fxLayout="column">
              <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 24px; margin-top: 10px; color: #707070; cursor: pointer" (click)="exportCsvData('usage')"></i>
            </div>
          </div>
        </nav>
      </article>
    </mat-card-header>
    <mat-card-content class="flx_tm">
      <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner>
      <app-highcharts #highchartsComponent [height]="'450px'" [marginTop]="'20px'" [sereiesType]="'column'" [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
      </app-highcharts>
    </mat-card-content>
  </mat-card>
</ng-container>
